import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fac954e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col-centered selection" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "title" }


export default /*#__PURE__*/_defineComponent({
  __name: 'LabeledInputContainer',
  props: {
    title: {},
    id: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", { for: _ctx.id }, [
      _renderSlot(_ctx.$slots, "title", { value: _ctx.title }, () => [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title) + ":", 1)
      ])
    ], 8, _hoisted_2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})